








import { BusinessBranchModel } from 'truemarket-modules/src/models/api/businesses'
import { Services } from 'truemarket-modules/src/services'
import { Component, Vue } from 'vue-property-decorator'

import ImageGallery from '@/components/Controls/ImageGallery.vue'

@Component({
  components: {
    ImageGallery
  }
})
export default class DashboardBusinessBranchDetails extends Vue {
  private branch: BusinessBranchModel | null = null;

  mounted () {
    this.updateBranch()
  }

  updateBranch () {
    Services.API.Businesses.GetBranch(this.$route.params.branchId).then((branch) => {
      this.branch = branch
    })
  }
}
